import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({ eyebrow, title, desc, moreTo, moreLabel = "查看全部" }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-700">
            <i className="ri-bookmark-3-line" aria-hidden="true"></i>
            {eyebrow}
          </span>
        )}
        <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">{title}</h2>
        {desc && <p className="mt-1.5 max-w-2xl text-sm text-foreground-500">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="group flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" aria-hidden="true"></i>
        </Link>
      )}
    </div>
  );
}